import React from 'react';

const stats = [
  { label: 'Albums Created', value: '48K+' },
  { label: 'Tracks Logged', value: '620K+' },
  { label: 'Artists', value: '12K+' },
];

export default function AuthBrandPanel() {
  return (
    <div className="hidden lg:flex w-[520px] xl:w-[580px] flex-col justify-between bg-dark-surface border-r border-dark-border relative overflow-hidden px-12 py-14">
      {/* Background atmosphere */}
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-[-80px] left-[-80px] w-[400px] h-[400px] rounded-full bg-brand-violet opacity-[0.06] blur-[80px]" />
        <div className="absolute bottom-[-60px] right-[-60px] w-[300px] h-[300px] rounded-full bg-brand-cyan opacity-[0.06] blur-[60px]" />
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[200px] h-[200px] rounded-full bg-brand-violet opacity-[0.04] blur-[40px]" />
      </div>
      {/* Logo */}
      <div className="relative z-10">
        <div className="flex items-center gap-3 mb-16">
          <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-brand-violet to-brand-violet-dark flex items-center justify-center shadow-neon-violet">
            <svg width="22" height="22" viewBox="0 0 22 22" fill="none">
              <path d="M11 2.5L17 8.5V19H5V8.5L11 2.5Z" stroke="#fff" strokeWidth="1.5" strokeLinejoin="round" fill="none"/>
              <line x1="7.5" y1="10" x2="14.5" y2="10" stroke="#06b6d4" strokeWidth="1.5" strokeLinecap="round"/>
              <line x1="6.5" y1="13" x2="15.5" y2="13" stroke="#06b6d4" strokeWidth="1.5" strokeLinecap="round"/>
              <line x1="8" y1="16" x2="14" y2="16" stroke="#06b6d4" strokeWidth="1.5" strokeLinecap="round"/>
            </svg>
          </div>
          <span className="font-semibold text-xl text-white tracking-tight">TrackLab</span>
        </div>

        {/* Hero copy */}
        <h1 className="text-4xl xl:text-5xl font-bold text-white leading-[1.1] tracking-tight mb-6">
          Your album,
          <br />
          <span className="text-gradient-violet">built from</span>
          <br />
          the ground up.
        </h1>
        <p className="text-gray-400 text-base leading-relaxed max-w-sm">
          Plan tracks, design covers, write lyrics, and coordinate releases — all inside one focused workspace per album.
        </p>
      </div>
      {/* Feature list */}
      <div className="relative z-10 space-y-4 my-12">
        {[
          { icon: '🎵', label: 'Tracklist & BPM planner', desc: 'Organize every track with key, tempo, and status' },
          { icon: '🎨', label: 'Cover art & mood boards', desc: 'Visual inspiration boards for your aesthetic' },
          { icon: '✍️', label: 'Lyric & notes editor', desc: 'Write, draft, and iterate on every song' },
          { icon: '📅', label: 'Release planning calendar', desc: 'Set deadlines and coordinate your launch' },
        ]?.map((f) => (
          <div key={`feature-${f?.label}`} className="flex items-start gap-3">
            <div className="w-9 h-9 rounded-lg bg-dark-elevated border border-dark-border flex items-center justify-center text-base flex-shrink-0">
              {f?.icon}
            </div>
            <div>
              <p className="text-sm font-medium text-white">{f?.label}</p>
              <p className="text-xs text-gray-500 mt-0.5">{f?.desc}</p>
            </div>
          </div>
        ))}
      </div>
      {/* Stats */}
      <div className="relative z-10 flex gap-8">
        {stats?.map((s) => (
          <div key={`stat-${s?.label}`}>
            <p className="text-2xl font-bold text-gradient-violet font-mono-data">{s?.value}</p>
            <p className="text-xs text-gray-500 mt-0.5">{s?.label}</p>
          </div>
        ))}
      </div>
    </div>
  );
}